module.exports = __webpack_public_path__ + "img/infra_busy.515384ce.svg";